/**
 * 门户端-解决方案
 */

import request from "@/utils/request";

/**
 * 分页查询
 */
export function getList(params) {
  return request({
    url: "/api/v1/portal/solution",
    method: "get",
    params
  });
}

/**
 * 详情获取
 */
export function getDetails(params) {
  const { id } = params
  return request({
    url: "/api/v1/portal/solution/" + id,
    method: "get",
    params
  });
}

export default {
  getList,
  getDetails,
};
